const easeljs = require('easeljs-loader!createjs-easeljs/lib/easeljs-0.8.2.min');

let socketSubscriptions = {},
    clockInterval = null;

let ct=[],last,sd;
function ab(ar){
    let ac=function(ar){
        let as = ar.reduce(function(as,av){
            return as + av;
        });
        return as/ar.length;
    };
    let ag=ac(ar);
    let ad = ar.map(function(av){
        return Math.pow(av-ag,2);
    });
    return Math.sqrt(ac(ad));
}
function filterOutliers(someArray) {

    // Copy the values, rather than operating on references to existing values
    var values = someArray.concat();

    // Then sort
    values.sort( function(a, b) {
            return a - b;
         });

    /* Then find a generous IQR. This is generous because if (values.length / 4)
     * is not an int, then really you should average the two elements on either
     * side to find q1.
     */
    var q1 = values[Math.floor((values.length / 4))];
    // Likewise for q3.
    var q3 = values[Math.ceil((values.length * (3 / 4)))];
    var iqr = q3 - q1;

    // Then find min and max values
    var maxValue = q3 + iqr*1.5;
    var minValue = q1 - iqr*1.5;

    // Then filter anything beyond or beneath these values.
    var filteredValues = values.filter(function(x) {
        return (x <= maxValue) && (x >= minValue);
    });

    // Then return
    return filteredValues;
}


class GameController{
    /*@ngInject*/
    constructor(SocketService,$window,$interval,EventService,SessionService,$timeout,FocusService, $state,UserService){
        this.socket = SocketService;
        this.window = $window;
        this.$interval = $interval;
        this.event = EventService;
        this.session = SessionService;
        this.$timeout = $timeout;
        this.focus = FocusService;
        this.$state = $state;
        this.user = UserService.getUser();

    }
    $onDestroy(){
        this.socket.send('leaveGame');
        Object.keys(socketSubscriptions).forEach(key=>{
            socketSubscriptions[key]();
            console.log('killed: '+key);
        });
        if(clockInterval!==null){
            this.$interval.cancel(clockInterval);
        }
        easeljs.Ticker.removeAllEventListeners();
    }
    $onInit(){
        this.gameStarting = false;
        this.socket.send('navigate',{page:'game'});
        this.game = {
            players: [],
            text: null,
            inProgress:false,
            status:'',
            start:null,
            delta:'0:00',
            playerInput:'',
            currentWord:0,
            progress:0,
            charactersTyped:0,
            wpm:0,
            mode:'easy',
        };
        this.handleGameData();
        socketSubscriptions.gameUpdated = this.event.subscribe('game.updated',data=>{
            this.session.set('gameData',data);
            this.handleGameData();
        });
        socketSubscriptions.gameReadyDelay = this.event.subscribe('game.ready.delay',()=>this.gameStarting = true);
        socketSubscriptions.gameReady = this.event.subscribe('game.ready',()=>this.game.status = 'ready.init');
        socketSubscriptions.gameSet = this.event.subscribe('game.set',()=>this.game.status='set.init');
        socketSubscriptions.gameGo = this.event.subscribe('game.go',()=>this.game.status='go.init');
        socketSubscriptions.gameStart = this.event.subscribe('game.start',()=>{
            this.game.status = 'started';
            this.game.inProgress = true;
            this.game.start = new Date();
            this.game.players.forEach(p => p.animationStatus = 'engineOn');
            this.focus.focus('gameInput');
            ct=[];
            last=(new Date()).getTime();
        });
        socketSubscriptions.invalid = this.event.subscribe('cheater',()=>{
            this.$state.go('cheat');
        });
        this.stage = null;
        this.spriteSheet = null;
        this.graySpriteSheet = null;
        this.invertSpriteSheet = null;
        this.canvasReady = false;
        this.initCanvas();
        clockInterval = this.$interval(this.updateTicker.bind(this),200);
        this.playerOne = false;
    }
    forceStart(){
        this.socket.send('gameStart');
    }
    goHome(){
        this.socket.send('leaveGame');
        return this.$state.go('dashboard');
    }

    handleGameData(){
        let data = this.session.get('gameData');
        if(typeof data.mode !== 'undefined'){
            this.game.mode = data.mode;
        }
        if(data.members.length>this.game.players.length){
            let ids = this.game.players.map(player=>player.id);
            data.members.forEach(member=>{
                if(ids.indexOf(member.id)===-1) {
                    member.x = -300;
                    member.animationStatus = 'join';
                    this.insertPlayer(member);
                }
            });
        }
        if(data.members.length<this.game.players.length){
            let ids = data.members.map(member=>member.id);
            this.game.players.forEach(player=>{
                if(ids.indexOf(player.id)===-1) {
                    if(player.progress < 1) {
                        player.animationStatus = 'disappear';
                    }
                }
            });
        }
        if(this.game.text===null){
            this.game.text = atob(data.text).split(' ');
        }
        if(this.game.start!==null){
            this.game.players.forEach(player=>{
                let member = data.members.find(m=>m.id===player.id);
                if(typeof member === 'undefined'){
                    return;
                }
                player.progress = member.progress;
                player.wpm = member.wpm;
                if(player.progress >= 1 && player.place===null){
                    let lowestPlace = 0;
                    this.game.players.forEach(p=>{
                        if(p.place !== null && p.place>lowestPlace){
                            lowestPlace = p.place;
                        }
                    });
                    player.place = lowestPlace + 1;
                }
                if(player.id==this.session.get('id')){
                    this.game.wpm = player.wpm;
                }
            });
        }

    }
    insertPlayer(player){
        let openLane = [true,true,true,true,true,true,true,true];
        this.game.players.forEach(p=>{
            openLane[p.lane]=false;
        });
        player.lane = openLane.indexOf(true);
        player.progress = 0;
        player.wpm = 0;
        player.place=null;
        if(player.id==this.session.get('id') && player.lane===0){
            this.$timeout(()=> {
                this.playerOne = true;
            });
        }
        this.game.players.push(player);
    }
    playAgain(){
        this.socket.send('leaveGame');
        return this.$state.go('character');
    }
    removePlayer(player){
        this.game.players = this.game.players.filter(p=>p.id!==player.id);
    }
    typingChange(){
        let p=new Date().getTime();
        ct.push(p-last);
        last=p;
        let l = this.game.playerInput.length;
        if(this.game.currentWord === this.game.text.length-1 &&
            l === this.game.text[this.game.currentWord].length &&
            this.game.playerInput === this.game.text[this.game.currentWord]){
            this.game.currentWord++;
            this.game.playerInput = '';
            this.game.charactersTyped += l;
            this.game.progress=this.game.currentWord/this.game.text.length;
            // ct = ct.splice(1,ct.length-2);
            ct.sort((a,b)=>a-b);
            // console.log(ct);
            // console.log(ab(ct));
            let filtered = filterOutliers(ct);
            // console.log(filtered);
            // console.log(ab(filtered));
            sd = ab(filtered);
            this.updateWpm(this.game.text.join(" ").length);
            this.socket.send('gameProgress',{progress:this.game.progress,wpm:this.game.wpm,sd:sd});
            let stats = this.session.get('stats',[]);
            let avatar = 'chicken';
            this.game.players.forEach(p=>{
                if(p.id==this.session.get('id')){
                    avatar = p.avatar;
                }
            });
            let effort = new Date() - this.game.start;
            stats.push({wpm:this.game.wpm,date:new Date(),level:this.game.mode,avatar:avatar,effort:effort/1000});
            this.session.set('stats',stats,true);
            this.game.status='finished';
            return;
        }
        if(l > this.game.text[this.game.currentWord].length && !this.game.incorrect && this.game.playerInput.slice(-1)==' '){
            this.game.currentWord++;
            this.game.playerInput = '';
            this.game.charactersTyped += l;
            this.game.progress=this.game.currentWord/this.game.text.length;
            this.updateWpm(this.game.charactersTyped);
            this.socket.send('gameProgress',{progress:this.game.progress,wpm:this.game.wpm});
            return;
        }
        this.game.incorrect = this.game.text[this.game.currentWord].substring(0,l) != this.game.playerInput;

    }

    updateTicker(){
        if(this.game.start===null || this.game.progress >= 1){
            return false;
        }
        let delta = new Date() - this.game.start;
        let seconds = Math.floor(delta/1000);
        let minutes = Math.floor(seconds/60);
        let remainder = seconds % 60;
        if(isNaN(remainder)){
            remainder = 0;
        }
        this.game.delta = minutes+":"+(remainder<10?"0":'')+remainder;
    }

    updateWpm(characters){
        if(this.game.start===null){
            return 0;
        }
        let words = characters/5;
        let minutes = (new Date() - this.game.start)/60000;
        this.game.wpm = words/minutes;
    }

    initCanvas() {
        this.stage = new easeljs.Stage(document.getElementById('game-stage'));
        easeljs.Ticker.on("tick", this.draw.bind(this));
        let bgImage = new easeljs.Bitmap('/assets/img/RaceTrack.jpg').setTransform(0, 0, 2, 2);
        this.stage.addChild(bgImage);
        let finishImage = new easeljs.Bitmap('/assets/img/RaceTrackFinish.jpg').setTransform(0, 0, 2, 2);
        finishImage.x=2400;
        this.stage.addChild(finishImage);

        let grayscaleFilter = new easeljs.ColorMatrixFilter([
            0.30,0.30,0.30,0,0, // red component
            0.30,0.30,0.30,0,0, // green component
            0.30,0.30,0.30,0,0, // blue component
            0,0,0,1,0  // alpha
        ]);

        let invert = new easeljs.ColorMatrix();
        invert.adjustHue(180);
        let invertFilter = new easeljs.ColorMatrixFilter(invert);

        let spritesheetBmp,spritesheetGrayBmp,spritesheetInvertBmp;

        let img = document.createElement("img");
        if(typeof this.user.appId !== 'undefined' && this.user.appId.toLowerCase()!=='kbk'){
            img.src = "/assets/img/sprites2.png";

            img.onload = ()=>{
                spritesheetBmp = new easeljs.Bitmap(img);
                spritesheetBmp.cache(0,0,1728,2592);
                let ss = {
                    images: [spritesheetBmp.cacheCanvas],
                    frames: {width: 288, height: 288},
                    animations: {
                        chicken: [0,5],
                        elephant: [6, 11],
                        gator: [12, 17],
                        giraffe: [18, 23],
                        lion: [24, 29],
                        monkey: [30, 35],
                        rhino: [36, 41],
                        trex: [42, 47]
                    },
                    framerate: 10
                };
                this.spriteSheet = new easeljs.SpriteSheet(ss);

                spritesheetGrayBmp = new easeljs.Bitmap(img);
                spritesheetGrayBmp.filters = [grayscaleFilter];
                spritesheetGrayBmp.cache(0,0,1728,2592);
                let ssg = {
                    images: [spritesheetGrayBmp.cacheCanvas],
                    frames: {width: 288, height: 288},
                    animations: {
                        chicken: [0,5],
                        elephant: [6, 11],
                        gator: [12, 17],
                        giraffe: [18, 23],
                        lion: [24, 29],
                        monkey: [30, 35],
                        rhino: [36, 41],
                        trex: [42, 47]
                    },
                    framerate: 10
                };
                this.graySpriteSheet = new easeljs.SpriteSheet(ssg);

                spritesheetInvertBmp = new easeljs.Bitmap(img);
                spritesheetInvertBmp.filters = [invertFilter];
                spritesheetInvertBmp.cache(0,0,1728,2592);
                let ssi = {
                    images: [spritesheetInvertBmp.cacheCanvas],
                    frames: {width: 288, height: 288},
                    animations: {
                        chicken: [0,5],
                        elephant: [6, 11],
                        gator: [12, 17],
                        giraffe: [18, 23],
                        lion: [24, 29],
                        monkey: [30, 35],
                        rhino: [36, 41],
                        trex: [42, 47]
                    },
                    framerate: 10
                };
                this.invertSpriteSheet = new easeljs.SpriteSheet(ssi);
                this.canvasReady = true;
            };

        }else{

            img.src = "/assets/img/sprites.png";
            img.onload = ()=>{
                spritesheetBmp = new easeljs.Bitmap(img);
                spritesheetBmp.cache(0,0,1200,2400);
                let ss = {
                    images: [spritesheetBmp.cacheCanvas],
                    frames: {width: 300, height: 300},
                    animations: {
                        chicken: [0, 3],
                        elephant: [4, 7],
                        gator: [8, 11],
                        giraffe: [12, 15],
                        lion: [16, 19],
                        monkey: [20, 23],
                        rhino: [24, 27],
                        trex: [28, 31]
                    },
                    framerate: 10
                };
                this.spriteSheet = new easeljs.SpriteSheet(ss);

                spritesheetGrayBmp = new easeljs.Bitmap(img);
                spritesheetGrayBmp.filters = [grayscaleFilter];
                spritesheetGrayBmp.cache(0,0,1200,2400);
                let ssg = {
                    images: [spritesheetGrayBmp.cacheCanvas],
                    frames: {width: 300, height: 300},
                    animations: {
                        chicken: [0, 3],
                        elephant: [4, 7],
                        gator: [8, 11],
                        giraffe: [12, 15],
                        lion: [16, 19],
                        monkey: [20, 23],
                        rhino: [24, 27],
                        trex: [28, 31]
                    },
                    framerate: 10
                };
                this.graySpriteSheet = new easeljs.SpriteSheet(ssg);

                spritesheetInvertBmp = new easeljs.Bitmap(img);
                spritesheetInvertBmp.filters = [invertFilter];
                spritesheetInvertBmp.cache(0,0,1200,2400);
                let ssi = {
                    images: [spritesheetInvertBmp.cacheCanvas],
                    frames: {width: 300, height: 300},
                    animations: {
                        chicken: [0, 3],
                        elephant: [4, 7],
                        gator: [8, 11],
                        giraffe: [12, 15],
                        lion: [16, 19],
                        monkey: [20, 23],
                        rhino: [24, 27],
                        trex: [28, 31]
                    },
                    framerate: 10
                };
                this.invertSpriteSheet = new easeljs.SpriteSheet(ssi);
                this.canvasReady = true;
            };
        }

        let smoke = {
            images: ["/assets/img/Smoke/smokePlume.png"],
            frames: {width: 300, height: 300},
            animations: {
                disappear: [0, 9]
            },
            framerate: 10
        };
        this.smokeSpriteSheet = new easeljs.SpriteSheet(smoke);
    }
    draw(event){
        if(!this.canvasReady){
            return;
        }
        if(this.game.status==='ready.init' || this.game.status==='set.init' || this.game.status==='go.init'){
            let next='',displayText='';
            switch(this.game.status){
                case 'ready.init':
                    next='ready.animate';
                    displayText='Ready';
                    break;
                case 'set.init':
                    next='set.animate';
                    displayText='Set';
                    break;
                case 'go.init':
                    next='go.animate';
                    displayText='Go!';
                    break;
            }
            let text = new easeljs.Text(displayText, "250px Lato", "#000000");
            text.shadow = new easeljs.Shadow("#555555", 0, 0, 5);
            text.x = 1200 - text.getMeasuredWidth()/2;
            text.y = 450 - text.getMeasuredHeight()/2;
            this.stage.addChild(text);
            this.game.textDraw = text;
            this.game.status = next;
        }else if(this.game.status==='ready.animate' || this.game.status==='set.animate' || this.game.status==='go.animate'){
            let next='';
            switch(this.game.status){
                case 'ready.animate':
                    next='ready.fade';
                    break;
                case 'set.animate':
                    next='set.fade';
                    break;
                case 'go.animate':
                    next='go.fade';
                    break;
            }
            let font = parseInt(this.game.textDraw.font.split('px ')[0])+25;
            this.game.textDraw.font = font+'px Lato';
            this.game.textDraw.x = 1200 - this.game.textDraw.getMeasuredWidth()/2;
            this.game.textDraw.y = 450 - this.game.textDraw.getMeasuredHeight()/2;
            if(font >= 500){
                this.game.status = next;
            }
        }else if(this.game.status==='ready.fade' || this.game.status==='set.fade' || this.game.status==='go.fade'){
            let next='',socketMessage='';
            switch(this.game.status){
                case 'ready.fade':
                    socketMessage = 'readyDone';
                    break;
                case 'set.fade':
                    socketMessage = 'setDone';
                    break;
                case 'go.fade':
                    socketMessage = 'goDone';
                    next='started';
                    break;
            }
            this.game.textDraw.alpha = this.game.textDraw.alpha - 0.1;
            if(this.game.textDraw.alpha <= 0){
                this.stage.removeChild(this.game.textDraw);
                // if(this.playerOne){
                //     this.socket.send(socketMessage);
                // }
            }
        }

        if(this.game.status==='finished'){
            this.stage.x = this.stage.x - 100;
            if(this.stage.x<=-2400){
                this.game.status = 'winnerCircle';
            }
        }
        this.game.players.forEach((player)=>{
            if(player.animationStatus === 'disappear'){
                let sprite = new easeljs.Sprite(this.smokeSpriteSheet, 'disappear');
                sprite.shadow = new easeljs.Shadow("#000000", -3, 3, 3);
                sprite.y = player.sprite.y;
                sprite.x = player.sprite.x-10;
                sprite.on('animationend',event=> {
                    sprite.off('animationend');
                    this.stage.removeChild(sprite);
                },null,true);
                this.stage.addChild(sprite);
                player.animationStatus='disappearing';
            }
            if(player.animationStatus==='disappearing'){
                player.sprite.alpha = player.sprite.alpha-0.1;
                player.text.alpha = player.text.alpha-0.1;
                if(player.sprite.alpha <=0 ){
                    this.stage.removeChild(player.sprite);
                    this.stage.removeChild(player.text);
                    player.animationStatus='null';
                    this.removePlayer(player);
                }
            }
            if(player.animationStatus === 'join') {
                let text = new easeljs.Text(player.name, "55px Lato", "#000000");
                text.x = 1200 - text.getMeasuredWidth()/2;
                text.y = lines[player.lane] - 70;
                text.skewX = -10;
                text.shadow = new easeljs.Shadow("#555555", 3, 3, 3);
                this.stage.addChildAt(text,(player.lane*2)+2);
                let sprite;
                if(player.bot) {
                    sprite = new easeljs.Sprite(this.graySpriteSheet, player.avatar).setTransform(0, 0, 0.8, 0.8);
                }else{
                    if(typeof player.admin !=='undefined' && player.admin){
                        sprite = new easeljs.Sprite(this.invertSpriteSheet, player.avatar).setTransform(0, 0, 0.8, 0.8);
                    }else{
                        sprite = new easeljs.Sprite(this.spriteSheet, player.avatar).setTransform(0, 0, 0.8, 0.8);
                    }
                }
                sprite.shadow = new easeljs.Shadow("#000000", -3, 3, 3);
                sprite.y = lines[player.lane] - (300 * 0.8) + getData(this.user)[player.avatar].lineOffset;
                sprite.x = -300;
                this.stage.addChildAt(sprite,(player.lane*2)+3);


                player.sprite = sprite;
                player.text = text;
                player.animationStatus = 'pre';
                this.game.status = 'players.joining';
            }
            if(player.animationStatus === 'pre'){
                player.sprite.x = player.sprite.x+5;
                if(player.sprite.x===0){
                    setTimeout(()=>player.sprite.stop(),300);
                    player.animationStatus='wait';
                    if(this.game.players.every(p=>p.animationStatus==='wait')){
                        this.$timeout(()=>this.game.status='players.waiting');
                    }

                }
            }
            if(player.animationStatus === 'engineOn'){
                player.sprite.play();
                player.animationStatus = 'engineRunning';
            }
            if(player.animationStatus === 'engineRunning'){
                let x = 2160 * player.progress;
                if(player.progress===1){
                    player.animationStatus = 'finished';
                }
                let playerX = player.sprite.x;
                if(playerX < x){
                    let diff = x-playerX;
                    player.sprite.x = playerX + (diff/30);
                }
            }
            if(player.animationStatus === 'finished'){
                player.sprite.x += 50;
                player.text.x+=50;
                if(player.sprite.x>=4300){
                    player.sprite.stop();
                    player.text.text = player.text.text + " @ "+(Math.round(player.wpm*100)/100)+" WPM!";
                    player.animationStatus = 'complete';
                    let suffix,trophy=null;
                    switch(player.place){
                        case 1:
                            suffix = 'st';
                            trophy = 'smallgold1.png';
                            break;
                        case 2:
                            suffix = 'nd';
                            trophy = 'smallsilver1.png';
                            break;
                        case 3:
                            suffix = 'rd';
                            trophy = 'smallbronze1.png';
                            break;
                        default:
                            suffix = 'th';
                            break;
                    }
                    let fontSize = 70 - (3* (player.place-1));
                    let placeText = new easeljs.Text(player.place+suffix+' Place!', fontSize+"px Lato", "#000000");
                    placeText.shadow = new easeljs.Shadow("#FFFFFF", 0, 0, 10);
                    placeText.x = 2500;
                    placeText.y = player.text.y;
                    this.stage.addChild(placeText);
                    if(trophy!==null){

                        player.placeImage = [
                            new easeljs.Bitmap('/assets/img/'+trophy).setTransform(0, 0, 2, 2),
                            new easeljs.Bitmap('/assets/img/'+trophy).setTransform(0, 0, 2, 2)
                            ];
                        player.placeImage[0].x = 2470;
                        player.placeImage[0].regX = 10;
                        player.placeImage[0].y = player.text.y+35;
                        player.placeImage[0].regY = 15;
                        player.placeImage[0].shadow = new easeljs.Shadow("#555555", 0, 0, 10);
                        player.placeImage[1].x = 2500 + placeText.getMeasuredWidth() + 32;
                        player.placeImage[1].regX = 10;
                        player.placeImage[1].y = player.text.y+35;
                        player.placeImage[1].regY = 15;
                        player.placeImage[1].shadow = new easeljs.Shadow("#555555", 0, 0, 10);
                        player.animationStatus = 'animateTrophies+';
                        this.stage.addChild(player.placeImage[0],player.placeImage[1]);
                    }
                }
            }
            if(player.animationStatus === 'animateTrophies+'){
                player.placeImage[0].rotation = player.placeImage[0].rotation + 3;
                player.placeImage[1].rotation = player.placeImage[1].rotation - 3;
                if(player.placeImage[0].rotation >= 15){
                    player.animationStatus = 'animateTrophies-';
                }
            }
            if(player.animationStatus === 'animateTrophies-'){
                player.placeImage[0].rotation = player.placeImage[0].rotation - 3;
                player.placeImage[1].rotation = player.placeImage[1].rotation + 3;
                if(player.placeImage[1].rotation >= 15){
                    player.animationStatus = 'animateTrophies+';
                }
            }
        });

        this.stage.update(event);
    }
}

function getData(user){
    if(typeof user.appId === 'undefined' || user.appId.toLowerCase() === 'kbk'){
        return {
            chicken:{
                lineOffset:44,
                yOffset:0,
                width:300,
                height:300,
                frames:4
            },
            elephant:{
                lineOffset:2,
                yOffset:300,
                width:300,
                height:300,
                frames:4
            },
            gator:{
                lineOffset:44,
                yOffset:600,
                width:300,
                height:300,
                frames:4
            },
            giraffe:{
                lineOffset:12,
                yOffset:900,
                width:300,
                height:300,
                frames:4
            },
            lion:{
                lineOffset:28,
                yOffset:1200,
                width:300,
                height:300,
                frames:4
            },
            monkey:{
                lineOffset:56,
                yOffset:1500,
                width:300,
                height:300,
                frames:4
            },
            rhino:{
                lineOffset:30,
                yOffset:1800,
                width:300,
                height:300,
                frames:4
            },
            trex:{
                lineOffset:24,
                yOffset:2100,
                width:300,
                height:300,
                frames:4
            }
        };
    }
    return {
        chicken:{
            lineOffset:44,
            yOffset:0,
            width:300,
            height:300,
            frames:4
        },
        elephant:{
            lineOffset:40,
            yOffset:300,
            width:300,
            height:300,
            frames:4
        },
        gator:{
            lineOffset:44,
            yOffset:600,
            width:300,
            height:300,
            frames:4
        },
        giraffe:{
            lineOffset:40,
            yOffset:900,
            width:300,
            height:300,
            frames:4
        },
        lion:{
            lineOffset:40,
            yOffset:1200,
            width:300,
            height:300,
            frames:4
        },
        monkey:{
            lineOffset:40,
            yOffset:1500,
            width:300,
            height:300,
            frames:4
        },
        rhino:{
            lineOffset:40,
            yOffset:1800,
            width:300,
            height:300,
            frames:4
        },
        trex:{
            lineOffset:40,
            yOffset:2100,
            width:300,
            height:300,
            frames:4
        }
    };
}
const lines=[
    216,
    294,
    372,
    450,
    526,
    602,
    678,
    756,
];
export default GameController;



// WEBPACK FOOTER //
// ./public/app/game/game.controller.js